/** Filters/sort shared by both codebase repo listing hooks. */
export interface CodebaseReposFilters {
  search?: string;
  prBotOnly?: boolean;
  /** PR bot enabled OR has generated TECH_DOCS main doc. */
  prBotOrHasDocs?: boolean;
  /** name | enabled_first | has_dependencies. Always ascending. */
  sortBy?: string;
  /** GitLab: restrict to repos under this group/subgroup path prefix. */
  gitlabGroupPath?: string;
  /** Restrict to repos owned by this git org (provider-neutral owner prefix). */
  gitOrg?: string;
}

/** Query keys for the DB-backed repo listing (POST /listCodebaseRepos/). */
export const codebaseReposQueryKeys = {
  all: ['codebaseRepos'] as const,
  infinite: (orgUUID: string, userUUID: string, f: CodebaseReposFilters) =>
    [
      'codebaseRepos',
      'infinite',
      orgUUID,
      userUUID,
      f.search ?? '',
      f.prBotOnly ?? false,
      f.prBotOrHasDocs ?? false,
      f.sortBy ?? 'name',
      f.gitlabGroupPath ?? '',
      f.gitOrg ?? '',
    ] as const,
  page: (
    orgUUID: string,
    userUUID: string,
    pageIndex: number,
    pageSize: number,
    f: CodebaseReposFilters
  ) =>
    [
      'codebaseRepos',
      'page',
      orgUUID,
      userUUID,
      pageIndex,
      pageSize,
      f.search ?? '',
      f.prBotOnly ?? false,
      f.prBotOrHasDocs ?? false,
      f.sortBy ?? 'name',
      f.gitlabGroupPath ?? '',
      f.gitOrg ?? '',
    ] as const,
};
